/*
  Cuentas atrás de Kaninor (barra de anuncios y hero de la home).

  Marcado (snippet kaninor-countdown.liquid):
    <span data-kcd data-kcd-target="2026-11-23T00:00:00+01:00">
      <span data-kcd-running> … <span data-kcd-d></span> <span data-kcd-h></span> … </span>
      <span data-kcd-done hidden> … </span>
    </span>

  - data-kcd-d / -h / -m / -s: se rellenan con días, horas, minutos y segundos
    (horas, minutos y segundos con dos cifras).
  - data-kcd-compact: en vez de unidades sueltas, un único texto «4d 12h 30m».
  - Al llegar a cero se oculta [data-kcd-running] y se muestra [data-kcd-done].

  La fecha objetivo lleva su zona horaria, así que la cuenta es la misma para
  cualquier visitante, esté donde esté.
*/
(function () {
  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function update(el) {
    var target = Date.parse(el.getAttribute('data-kcd-target'));
    if (isNaN(target)) return true;
    var left = Math.max(0, Math.floor((target - Date.now()) / 1000));
    var running = el.querySelector('[data-kcd-running]');
    var done = el.querySelector('[data-kcd-done]');

    if (left === 0) {
      if (running) running.hidden = true;
      if (done) done.hidden = false;
      el.classList.add('is-done');
      return true;
    }

    var d = Math.floor(left / 86400);
    var h = Math.floor((left % 86400) / 3600);
    var m = Math.floor((left % 3600) / 60);
    var s = left % 60;

    var compact = el.querySelector('[data-kcd-compact]');
    if (compact) {
      compact.textContent = (d > 0 ? d + 'd ' : '') + h + 'h ' + pad(m) + 'm' + (d > 0 ? '' : ' ' + pad(s) + 's');
    }
    var set = function (sel, v) {
      var node = el.querySelector(sel);
      if (node) node.textContent = v;
    };
    set('[data-kcd-d]', d);
    set('[data-kcd-h]', pad(h));
    set('[data-kcd-m]', pad(m));
    set('[data-kcd-s]', pad(s));
    return false;
  }

  function start() {
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-kcd]'));
    if (!els.length) return;
    var tick = function () {
      els = els.filter(function (el) {
        return !update(el);
      });
      if (els.length) setTimeout(tick, 1000 - (Date.now() % 1000));
    };
    tick();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
